module.exports = __webpack_public_path__ + "static/media/rulesOne.4d165de6.webp";